<template>
  <div class="flex items-center justify-center" v-if="loading">
    <Spinner></Spinner>
  </div>
  <div v-else-if="classes.length != 0">
    <div v-for="session in classes" :key="session.id">
      <SessionLine :logged-in="loggedIn" class="mb-6" :style="'small'" :session="session"></SessionLine>
      <!--      <Session :session-id="session.id"></Session>-->
    </div>
    <div class="mt-2">
      <a class="g--button" href="/yoga-classes">See all classes</a>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import Spinner from './Spinner.vue';
import SessionLine from './SessionLine.vue';
import Session from './Session.vue';

const loading = ref(true);
const classes = ref([]);

const props = defineProps({
  yogaTypeId: {
    type: Number,
    default: 0
  },
  loggedIn: {
    default: false,
    type: Boolean
  },
});
onMounted(() => {
  console.log('sidebar mounted');
  console.log('yogaTypeId', props.yogaTypeId);
  getClasses();
});

const getClasses = async () => {
  const response = await fetch(`/api/sessions/all?fromNow=1&hidePrivate=1&limit=4&` + `&yogaTypeId=` + props.yogaTypeId);
  const data = await response.json();
  classes.value = data.sessions;
  loading.value = false;
}
</script>